import React, { useEffect, useRef, useState } from "react";
import { Tabs, Select } from "antd";
import {
  TeamOutlined,
  CalendarOutlined,
  BookOutlined,
  PlayCircleOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

import styles from "./index.module.scss";
import MembersTab from "./MembersTab";
import ChartsTab from "./ChartsTab";
import MeetingsTab from "./MeetingsTab";
import ReadingsTab from "./ReadingsTab";
import RecordingsTab from "./RecordingsTab";
import { useVaadTabs } from "./context";
import { useParams, useSearchParams } from "react-router";

const tabItems = [
  {
    key: "members",
    label: "Members",
    icon: <TeamOutlined />,
    Component: MembersTab,
  },
  {
    key: "meetings",
    label: "Meetings",
    icon: <CalendarOutlined />,
    Component: MeetingsTab,
  },
  {
    key: "readings",
    label: "Readings",
    icon: <BookOutlined />,
    Component: ReadingsTab,
  },
  {
    key: "recordings",
    label: "Recordings",
    icon: <PlayCircleOutlined />,
    Component: RecordingsTab,
  },
  {
    key: "charts",
    label: "Charts",
    icon: <BarChartOutlined />,
    Component: ChartsTab,
  },
];

export default function VaadTabs(): React.ReactElement {
  const { id } = useParams();
  const { activeTab, setActiveTab } = useVaadTabs();
  const [, setSearchParams] = useSearchParams();

  const handleTabChange = (key: string) => {
    // Pagination/filters are synced to the URL per-tab (ProTable syncToUrl),
    // so drop stale query params (e.g. current=2) when moving to another tab.
    setSearchParams({}, { replace: true });
    setActiveTab(key);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Tabs
          key={id}
          activeKey={activeTab}
          onChange={handleTabChange}
          className={styles.tabs}
          items={tabItems.map((item) => ({
            key: item.key,
            label: (
              <span className={styles.tabLabel}>
                {item.icon}
                {item.label}
              </span>
            ),
            children: <item.Component activeTab={activeTab} />, // ← передаём activeTab
          }))}
        />
      </div>
    </div>
  );
}
